/* unplugin-vue-components disabled */// extracted by mini-css-extract-plugin
export default {"tab_wrap":"tab_wrap-f5d1a719","active":"active-ae5c51aa"};